import { usePathname } from 'next/navigation'
import { useEffect } from 'react'

import getNotificationSettings from '@/libs/actions/notifications/get-notification-settings'
import { useAppDispatch } from '@/libs/hooks/use-app-dispatch'
import useFcmToken from '@/libs/hooks/use-fcm-token'
import { setShowNotificationRequest } from '@/libs/store/slice/ui-slice'

export default function NotificationRequestSetter() {
  const dispatch = useAppDispatch()
  const pathname = usePathname()
  const { notificationPermissionStatus } = useFcmToken()

  const handleSetNotificationRequest = async () => {
    const notificationSettings = (await getNotificationSettings())?.result?.webPushNotif

    if (
      (notificationPermissionStatus === 'granted' && notificationSettings) ||
      pathname === '/suspend'
    ) {
      dispatch(setShowNotificationRequest(false))
    } else {
      dispatch(setShowNotificationRequest(true))
    }
  }

  useEffect(() => {
    handleSetNotificationRequest()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return null
}
